<div class="short-details-wrapper">
    <div class="short-description" [innerHTML]="truncatedResult().displayText | safeHtml"></div>

    @if (truncatedResult().plainTextLength > MAX_CHARACTERS_TO_SHOW) {
    <div class="view-more-section d-flex flex-row justify-content-end">
        <div class="view-more-content">
            @if (!isExpanded) {
            <span (click)="toggleViewMoreComments()" class="view-more"> View More </span>
            } @if (isExpanded) {
            <span (click)="toggleViewMoreComments()" class="view-more"> View Less </span>
            }
        </div>
    </div>
    }
</div>